<template>
	
	<div class="mx-auto p-4 sm:p-4">
		<div class="mx-auto md:h-100% flex flex-col">
			<div class="btn-grup flex justify-between pb-3 border-b border-gray-3 mb-3 items-center">
				<button
					class="flex flex-row hover:bg-gray-4 items-center rounded py-2 px-4 text-center font-sans mr-2 text-xs font-bold hover:text-primary-500 transition-all bg-transparent border-gray-3 border text-primary"
					type="button" @click="handleBackButtonClick">
					<i class="tabler:arrow-left w-5 h-5 mr-1"></i>
					<span class="hidden md:inline">{{ labels.backbtn }}</span>
				</button>
			
				<div class="flex gap-2 mb-4">
					<!-- Pre-Quiz Button -->
						<button
						type="button"
						:class="[
							'inline-flex items-center gap-2 rounded py-2 px-3 text-center align-middle font-sans text-xs font-bold uppercase text-white transition-all',
							globalQuizMode === 'pre'
							? 'bg-black hover:bg-black/60'
							: 'bg-gray-200 text-black/80 hover:bg-gray-300'
						]"
						v-tooltip.bottom="'Pre-Quiz'"
						@click="globalQuizMode = 'pre'"
						>
						<i :class="['tabler:list-check w-5 h-5', globalQuizMode === 'pre' ? 'text-white' : 'text-black/60']"></i>
						</button>

						<!-- Post-Quiz Button -->
						<button
						type="button"
						:class="[
							'inline-flex items-center gap-2 rounded py-2 px-3 text-center align-middle font-sans text-xs font-bold uppercase transition-all',
							globalQuizMode === 'post'
							? 'bg-black text-white hover:bg-black/60'
							: 'bg-gray-200 text-black/80 hover:bg-gray-300'
						]"
						v-tooltip.bottom="'Post-Quiz'"
						@click="globalQuizMode = 'post'"
						>
						<i :class="['tabler:list-details w-5 h-5', globalQuizMode === 'post' ? 'text-white' : 'text-black/60']"></i>
						</button>


				</div>
			</div>
			<div v-for="quiz in validQuizeslistMode" :key="quiz.identifier"  class="bg-white shadow-sm rounded mb-4" style="border: 1px solid rgb(222, 222, 222, 0.5)">
				<!-- Title and Actions -->
				<div v-if=" isEditMode " class="flex items-center p-3 border-b border-gray-200">
					<div class="flex">
						<EditButton v-if=" AppConfig.editmode && showassistantConfigButton" class="rounded hover:bg-secondary-500/80 items-center py-1 px-1 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white mr-2"
						:id="quiz.identifier" type="configAssistantMode"

						/>

						<InplaceEdit
							:inputProps="[{ content: quiz.packageTitle, propName: 'packageTitle', inputType: 'input' }]"
							:href="quiz._links.self.href" blockTitle="Edit package title" :showAssistant="true">
							<strong class="ml-1">{{ quiz.packageTitle }}</strong>
						</InplaceEdit>
					</div>	
					<div class="ml-auto flex">
						<button v-if=" AppConfig.editmode "
							class="rounded hover:bg-danger-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-danger-500 transition-all bg-danger !text-white mr-2" @click="deleteItem(quiz._links.self.href)">
							<i class="tabler:trash w-5 h-5 text-white flex"></i>
						</button>
						<EditButton v-if=" AppConfig.editmode "
							class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white"
							:id="quiz.identifier" icon="tabler:settings" type="editPackage"
							:overrideURL="quiz._links.editAll.href" />
						</div>
					</div>
					<div class="flex flex-col  sm:flex-row justify-center mt-3">
						<div class="px-4 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1 relative">
							<EditButton
								class="absolute right-5px top-[-5px] inline-flex items-center gap-2 transition-all rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								v-if=" AppConfig.editmode && quiz._links.mainOutcome " :id="quiz.identifier" type="listattr"
								:overrideURL="quiz._links.preQuiz.href" />
							<InplaceEdit
								:inputProps="[{ content: quiz.mainOutcome.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
								:href="quiz._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true">
								<h6
									class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
									{{ quiz.mainOutcome.selectHeader }}
								</h6>
							</InplaceEdit>
							<div class="main-text md:line-clamp-3">
								<div>
									<InplaceEdit
										:inputProps="[{ content: quiz.mainOutcome.title, propName: 'title', inputType: 'textarea' }]"
										:href="quiz._links.mainOutcomeEdit?.href" blockTitle="Edit title"  :showAssistant="true"
										:textarea-props="{ rows: 3, class: 'min-w-[30rem]' }">
											<h4
												class="mb-2 inline-flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased">
												{{ quiz.mainOutcome.title }}
											</h4>
									</InplaceEdit>
									<div class="gap-3 flex items-center ">
										<InplaceEdit
											:inputProps="[
												{
													content: quiz.mainOutcome.publishingDate,
													propName: 'other.publishingDate',
													inputType: 'datepicker',
												},
											]"
											:href="quiz._links.mainOutcomeEdit?.href"
											blockTitle="Edit publishing date"
										>
											<div class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated(quiz.mainOutcome.publishingDate) }}
											</div>
										</InplaceEdit>
										<InplaceEdit
											:inputProps="[
												{
													content: quiz.mainOutcome.authorIdentifier,
													propName: 'other.authorIdentifier',
													inputType: 'select',
													selectProps: {
														optionValue: 'identifier',
														optionLabel: 'title',
														class: 'w-15rem',
														optionsCvKey: 'author',
													},
												},
											]"
											:href="quiz._links.mainOutcomeEdit?.href"
											blockTitle="Edit author"
										>
											<div class="ml-2 text-sm font-bold" v-html="quiz.mainOutcome.author"></div>
										</InplaceEdit>
									</div>
								</div>
							</div>
							<div class="text-gray-700">
								<div v-if="globalQuizMode === 'pre'">
									<div v-if="quiz.preQuiz.questions && quiz.preQuiz.questions.length">
										<div class="mb-2">
											<strong>Pre-quiz available.</strong>
										</div>
									</div>
									<div v-else class="text-gray-400">No pre-quiz available.</div>
								</div>
								<div v-else>
									<div v-if="quiz.postQuiz.questions && quiz.postQuiz.questions.length">
										<div class="mb-2">
											<strong>Post-quiz available.</strong>
										</div>
									</div>
									<div v-else class="text-gray-400">No post-quiz available.</div>
								</div>
							</div>
							<router-link
								:to="{ name: 'quizes-details', params: { id: quiz.identifier } }"
								class="flex-1 underline cursor-pointer md:text-sm text-sm"
							>
								Learn more
							</router-link>
						</div>

					</div>
				</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios'
import { DateTime } from 'luxon';

import { useAppConfig } from '@/composables/useAppConfig';

import type { Callout, ListFilters, PostListResponse } from '@/types';
import EditButton from '@/components/EditButton.vue'
import AuthoringStatus from '@/components/AuthoringStatus.vue'
import PublishingStatus from '@/components/PublishingStatus.vue'
import InplaceEdit from '@/components/InplaceEdit/InplaceEdit.vue'
import PreQuiz from '@/components/PreQuiz.vue'
import PostQuiz from '@/components/PostQuiz.vue'


import { messages } from '@/assets/language';
import { useAppStore } from '@/stores/app-store';

const { currentLng, currentMedicalFilter, currentStudyType, currentoutcomeType, currenttargetAudience, currentPublishingFilter, currentAuthoringFilter } = useAppStore()
const AppConfig = useAppConfig();

const filters = [
	currentLng,
	currentPublishingFilter,
	currentAuthoringFilter,
	currentMedicalFilter,
	currentStudyType,
	currentoutcomeType,
	[currenttargetAudience],
];

const route = useRoute();
const router = useRouter();

const labels = computed(() => {
	const key = currentLng.value as keyof typeof messages;
	return messages[key] ?? {};
});

const handleBackButtonClick = () => {
	router.push({ name: 'list', query: { ...route.query } });
};

const defaultFIlters = () => ({
	search: null,
	author: [],
	outcomeType: [],
	targetAudience: [],
	inputMaterialType: []
});
const emit = defineEmits<{
	authoringStatusChange: [Callout['authoringStatusCode']]
	publishingStatusChange: [Callout['publishingStatusCode']]
	titleUpdate: ['title-update']
	delete:[string]
}>()


const deleteItem = (url: string) => {
  console.log('Deleting item:', url);
  emit('delete', url);
};

const listFilters = ref<ListFilters>(defaultFIlters());

const props = withDefaults( defineProps<{

	selectedLanguage: string,
	isEditMode?: boolean,
	authoringStatusOptions?: Array<{ identifier: string; title: string }>;
	publishingStatusOptions?: Array<{ identifier: string; title: string }>;


}>(), {
	isEditMode: true,
	selectedLanguage: 'en'
} )

watch(
	() => props.selectedLanguage,
	(newLang) => {
		if (newLang) {
			console.log(`Gjuha e re nga prindi: ${newLang}`);
		} else {
			console.log('Gjuha nuk është kaluar ende.');
		}
	}
);

const showassistantConfigButton = computed(() => AppConfig.urls.assistantModeButtons?.configButton.enabled === true && AppConfig.urls.assistantModeButtons?.configButton.configAssistantLink !== '')
const showassistantFinishButton = computed(() => AppConfig.urls.assistantModeButtons?.finishButton.enabled === true && AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink !== '')


const quizeslistMode = ref<any[]>([]);
const validQuizeslistMode = computed(() => Array.isArray(quizeslistMode.value) ? quizeslistMode.value : []);

const globalQuizMode = ref<'pre' | 'post'>('pre');


function authoringStatusChange ( newStatus: Callout['authoringStatusCode'] ) {
	emit( 'authoringStatusChange', newStatus )
}

function publishingStatusChange ( newStatus: Callout['publishingStatusCode'] ) {
	emit( 'publishingStatusChange', newStatus )
}

onMounted(async () => {
	try {
		let params: Record<string, any> = {
			...route.query,
			...listFilters.value,
			lng: currentLng.value,
		};

		if (currentMedicalFilter.value) {
			params.medicalSpeciality = currentMedicalFilter.value;
		}
		if (currentPublishingFilter.value) {
			params.publishingStatus = currentPublishingFilter.value;
		}
		if (currentAuthoringFilter.value) {
			params.authoringStatus = currentAuthoringFilter.value;
		}

		if (currentStudyType.value) {
			params.studyType = currentStudyType.value;
		}
		if (currentoutcomeType.value) {
			params.outcomeType = currentoutcomeType.value;
		}
		if (currenttargetAudience.value) {
			params.targetAudience = [currenttargetAudience.value];
		}

		const url = `${AppConfig.urls.getList}?${params}`;

		const response = await axios.get<PostListResponse>(`${AppConfig.urls.getList}?json=y`, {
			params: params,
			headers: {
				'Content-Type': 'application/json',
				'Accept-Language': currentLng.value
			}
		});

		const jsonData = response.data;
		if (Array.isArray(jsonData.data)) {
			quizeslistMode.value = jsonData.data.map((quiz: any) => {
				// Normalize preQuiz
				let preQuiz = { questions: [] };
				if (Array.isArray(quiz.preQuiz) && quiz.preQuiz[0]?.questions) {
					preQuiz = { questions: quiz.preQuiz[0].questions };
				} else if (quiz.preQuiz && quiz.preQuiz.questions) {
					preQuiz = { questions: quiz.preQuiz.questions };
				}
				// Normalize postQuiz
				let postQuiz = { questions: [] };
				if (Array.isArray(quiz.postQuiz) && quiz.postQuiz[0]?.questions) {
					postQuiz = { questions: quiz.postQuiz[0].questions };
				} else if (quiz.postQuiz && quiz.postQuiz.questions) {
					postQuiz = { questions: quiz.postQuiz.questions };
				}
				return {
					...quiz,
					preQuiz,
					postQuiz,
				};
			});
			// console.log('quizeslistMode loaded:', quizeslistMode.value);
		} else {
			console.error('Expected an array but received:', jsonData.data);
			quizeslistMode.value = [];
		}
	} catch (error) {
		console.error('Failed to fetch data:', error);
	}
});

function publishingDateFormated(publishingDate?: string) {
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};
	const formatDate = (date: Date) => {
		return new Intl.DateTimeFormat('en-GB', options).format(date);
	};
	if (!publishingDate) {
		return formatDate(new Date());
	}
	const dateTime = DateTime.fromISO(publishingDate);
	if (!dateTime.isValid) {
		return formatDate(new Date());
	}
	return formatDate(dateTime.toJSDate());
}

</script>


